function Support() {
    const handleEmailClick = () => {
        window.location.href = 'mailto:pete@ngenart.com';
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Support</h1>

            <section style={styles.section}>
                <h2 style={styles.sectionTitle}>Contact Us</h2>
                <p style={styles.text}>
                    Having issues or questions about Day By Data? I'm here to help! Feel free to email me at pete@ngenart.com.
                </p>
                <button onClick={handleEmailClick} style={styles.emailButton}>
                    Email Support
                </button>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionTitle}>Frequently Asked Questions</h2>

                <div style={styles.faqItem}>
                    <h3 style={styles.questionTitle}>How do I connect my Apple Health data?</h3>
                    <p style={styles.answer}>
              Open the app and follow the onboarding process. You'll be prompted to allow access to your Apple Health data. You can also manage permissions in your iPhone's Settings > Privacy > Health > Data Access > Day By Data.
                    </p>
                </div>

                <div style={styles.faqItem}>
                    <h3 style={styles.questionTitle}>How do I connect my Spotify account?</h3>
                    <p style={styles.answer}>
                        During setup or whenever you try to access a Spotify feature, you'll be prompted to connect your Spotify account. Simply follow the authentication process to grant access to your listening data.
                    </p>
                </div>

                <div style={styles.faqItem}>
                    <h3 style={styles.questionTitle}>Is my data secure?</h3>
                    <p style={styles.answer}>
                        Yes! We process all data locally on your device and never store your personal health or music data off of your device. Therefore, it never leaves your device! Check our Privacy Policy for more details and please reach out with any questions!
                    </p>
                </div>

                <div style={styles.faqItem}>
                    <h3 style={styles.questionTitle}>How do I export my visualizations?</h3>
                    <p style={styles.answer}>
                        Tap the share button on any visualization to save it to your photos or share it directly to social media. You can also screenshot or screenrecord questions and share them as well!
                    </p>
                </div>

                <div style={styles.faqItem}>
                    <h3 style={styles.questionTitle}>Who's the team behind Day By Data?</h3>
                    <p style={styles.answer}>
                        Day by Data is a project by me, Pete Cybriwsky. I'm a data artist and software engineer and like to make creative visualizations with data. Day by Data is my first iOS app and a project I am excited to continue to evolve over time! I'm a one person team, so please reach out with any questions or feedback! I'd love to hear from you!
                    </p>
                </div>
            </section>


        </div>
    );
}

const styles = {
    container: {
        padding: '2rem',
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: '"Bodoni Moda", serif',
        backgroundColor: '#fffef7',
    },
    title: {
        fontSize: '2.5rem',
        marginBottom: '2rem',
        color: '#0a0a0a',
        textAlign: 'center',
    },
    section: {
        marginBottom: '3rem',
    },
    sectionTitle: {
        fontSize: '1.8rem',
        marginBottom: '1.5rem',
        color: '#0a0a0a',
    },
    text: {
        fontSize: '1.1rem',
        lineHeight: '1.6',
        color: '#0a0a0a',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
    },
    emailButton: {
        padding: '0.75rem 1.5rem',
        backgroundColor: '#0a0a0a',
        color: '#fffef7',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '1rem',
        fontFamily: '"Bodoni Moda", serif',
        transition: 'opacity 0.2s ease',
        ':hover': {
            opacity: 0.8,
        },
    },
    faqItem: {
        marginBottom: '2rem',
    },
    questionTitle: {
        fontSize: '1.2rem',
        fontWeight: '600',
        marginBottom: '0.5rem',
        color: '#0a0a0a',
    },
    answer: {
        fontSize: '1.1rem',
        lineHeight: '1.6',
        color: '#0a0a0a',
    },
};

export default Support;